import type { ReactNode } from 'react';

import {
  buildAuthorHref,
  type BuildAuthorHrefInput,
} from '@/features/media-authors/utils/build-author-href';
import { cn } from '@/lib/utils';

type MediaAuthorLinkProps = BuildAuthorHrefInput & {
  readonly className?: string;
  readonly children: ReactNode;
};

/**
 * Real author-profile link. Inactive authors render as plain text.
 */
export function MediaAuthorLink({
  slug,
  url,
  isActive,
  isPublished,
  className,
  children,
}: MediaAuthorLinkProps) {
  const href = buildAuthorHref({ slug, url, isActive, isPublished });
  if (!href) {
    return <span className={className}>{children}</span>;
  }
  return (
    <a href={href} rel="author" className={cn('hover:text-[#585cff] transition-colors', className)}>
      {children}
    </a>
  );
}
